import React from 'react'

const MailIcon = ({ color = '#999FAC' }) => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
      <path
        d="M3.33329 17.1663C2.87496 17.1663 2.48274 17.0033 2.15663 16.6772C1.82996 16.3505 1.66663 15.958 1.66663 15.4997V5.49967C1.66663 5.04134 1.82996 4.64912 2.15663 4.32301C2.48274 3.99634 2.87496 3.83301 3.33329 3.83301H16.6666C17.125 3.83301 17.5175 3.99634 17.8441 4.32301C18.1702 4.64912 18.3333 5.04134 18.3333 5.49967V15.4997C18.3333 15.958 18.1702 16.3505 17.8441 16.6772C17.5175 17.0033 17.125 17.1663 16.6666 17.1663H3.33329ZM9.99996 11.333L3.33329 7.16634V15.4997H16.6666V7.16634L9.99996 11.333ZM9.99996 9.66634L16.6666 5.49967H3.33329L9.99996 9.66634ZM3.33329 7.16634V5.49967V15.4997V7.16634Z"
        fill={color}
      />
    </svg>
  )
}

export default MailIcon

//url(#mask0_1262_32994)
